import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'



export interface IOperacoes extends IDataModel {
    codigo?: string,
    nome?: string,
    ordem?:number,
}

export class Operacoes extends DataModel<IOperacoes>  {
    constructor(private db: AngularFirestore) {
        super(db,'operacoes');
    }


    gerarNovoCodigo(proc){
        this.getNewID('codigo_operacoes',proc);
    }
 
   updateOrInsert(id,item,proc,err){
      let old = id;
      return super.updateOrInsert(item.id,item,r=>{
         if (proc) proc(r);
      },err);
   }


}
